// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --consumer-slides-message-z-index: 7999;
  --consumer-slides-message-background: rgba(255, 255, 255, 1);
  --consumer-slides-message-box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.1);
}

.consumer-slides-message {
  width: 400px;
  z-index: var(--consumer-slides-message-z-index);
  background: var(--consumer-slides-message-background);
  top: 30px;
  right: 30px;
  border-radius: 3px;
  box-shadow: var(--consumer-slides-message-box-shadow);
}

.consumer-slides-header {
  margin-top: -10px;
}`, "",{"version":3,"sources":["webpack://./src/components/consumer-slides-message/ConsumerSlidesMessage.css"],"names":[],"mappings":"AAAA;EACE,uCAAuC;EACvC,4DAA4D;EAC5D,yEAAyE;AAC3E;;AAEA;EACE,YAAY;EACZ,+CAA+C;EAC/C,qDAAqD;EACrD,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[":root {\n  --consumer-slides-message-z-index: 7999;\n  --consumer-slides-message-background: rgba(255, 255, 255, 1);\n  --consumer-slides-message-box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.1);\n}\n\n.consumer-slides-message {\n  width: 400px;\n  z-index: var(--consumer-slides-message-z-index);\n  background: var(--consumer-slides-message-background);\n  top: 30px;\n  right: 30px;\n  border-radius: 3px;\n  box-shadow: var(--consumer-slides-message-box-shadow);\n}\n\n.consumer-slides-header {\n  margin-top: -10px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
